import { CouponResponseDtos, CouponsResponseDto } from '@diritto/common/coupon/dtos/coupon.response.dtos';
import { Http } from '@diritto/common/utils/requester/http';
import { AxiosRequestConfig } from 'axios';

export class CouponCatalogApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getIssuedCoupons(couponCatalogId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<CouponsResponseDto>(
      `${this.url}/coupon-catalogs/${couponCatalogId}/issued`,
      options,
    );
    return res.data;
  }

  async issueCoupon(couponCatalogId: number) {
    const res = await this.http.post<undefined, CouponResponseDtos>(
      `${this.url}/coupon-catalogs/${couponCatalogId}/issue`,
    );
    return res.data;
  }

  async getCoupon(couponId: number) {
    const res = await this.http.get<CouponResponseDtos>(`${this.url}/coupons/${couponId}`);
    return res.data;
  }
}
